import { z } from 'zod';
/**
 * Study scene schema - a scene description for the study
 */
export const StudySceneSchema = z.object({
    descriptions: z.array(z.string()),
});
//# sourceMappingURL=study-scene.js.map